/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Same_DayInputs */

const en_notify_same_day = /** @type {(inputs: Notify_Same_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the day`)
};

const de_notify_same_day = /** @type {(inputs: Notify_Same_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Tag`)
};

/**
* | output |
* | --- |
* | "On the day" |
*
* @param {Notify_Same_DayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_same_day = /** @type {((inputs?: Notify_Same_DayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Same_DayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_same_day(inputs)
	return en_notify_same_day(inputs)
});